import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

@Component({
  name: 'CmgUpdatePasswordConfirmModal',
})
export default class CmgUpdatePasswordConfirmModal extends Vue {
  isWalletCleared = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.updatePasswordConfirmModal.visible;
  }

  get partyAvocadoVideoUrl() {
    return this.$appStore.state.cms.images.partyAvocado.default;
  }

  get args() {
    let walletClear = this.$appStore.state.ui.modals.updatePasswordConfirmModal.args;
    return walletClear;
  }

  get walletCleared(){
    const walletCleared = this.args?.isWalletCleared
    return walletCleared;
  }

  onClose() {
    this.$services.ui.setModalVisibility('updatePasswordConfirmModal', false);
    this.$services.ui.focusBack();
  }

  onClickAddPaymentMethod() {
    this.$router.push({ name: Routes.PaymentsAndGiftCards });
    this.onClose();
    this.$services.ui.nextFocus('payment-title');
  }

  onClickDone() {
    this.onClose();
  }
}
